import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getAllByCus = (customer_id, company_id) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/getbycustomer/${customer_id}/${company_id}`
    );
};

export const billing_expense_getAllHById = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/getAllById/${id}`);
};

export const billing_expense_getRequestHBycompanyPaginationV2 = (
    offset,
    limit,
    sortBy,
    sortOrder,
    employee_id,
    company_id,
    search,
    datefrom,
    dateto,
    search_status
) => {

    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}/getbycompany-paginationV2/${employee_id}/${company_id}`,
        {
            params: {
                limit,
                offset,
                sortBy,
                sortOrder,
                search,
                datefrom,
                dateto,
                search_status,
            },
        }
    );
};

export const billing_expense_getDetailiIdAdvance = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}/detailadvanceid/${id}`);
};

export const billing_expense_getclearRequestHByCompany = (employee_id, query) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/getclearbycompany/${employee_id}`,
        query
    );
};

export const billing_expense_addAdvanceH = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}`, data);
};

export const billing_expense_sendMail = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/sendMail`, data);
};

export const billing_expense_updateAdvanceH = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/${id}`, data);
};

export const billing_expense_deleteAdvanceH = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/${id}`);
};

export const billing_expense_getapproveAdvanceByCompanyPaginationV2 = (
    page,
    limit,
    sortBy,
    sortOrder,
    id,
    company_id,
    datefrom,
    dateto,
    search
) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/getapproveadvancebycompany-pagination-v2/${id}`,
        {
            params: {
                page,
                limit,
                sortBy,
                sortOrder,
                company_id,
                datefrom,
                dateto,
                search,
            },
        }
    );
};

export const billing_expense_updateclearAdvanceH = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/clear/${id}`, data);
};

export const billing_expense_getAccountPendingByCompany = (query) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/accountpendingbycompany`,
        query
    );
};
export const billing_expense_getAccountClearByCompany = (query) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/accountclearbycompany`,
        query
    );
};

export const billing_expense_getDepartmentByID = (id) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/get-department/${id}`
    );
};

export const billing_expense_gatAdvanceHByManyId = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.ADVANCE_H_URL}` + `/getAllById/select`, data);
};